import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { Button, H7, Stack } from '@qred/components-library';
import PaymentCalculatorModal from '../PaymentCalculator/PaymentCalculatorModal';
import useModals from '~/hooks/useModals';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { useLoanOfferSelectors } from '~/store/selectors/loanOffer.selector';
import PaymentDetails from './PaymentDetails';
import LoanOfferAdjustmentForm from './LoanOfferAdjustmentForm';

const LoanOfferAdjustment = () => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const modals = useModals();

  const { loanAmount } = useLoanOfferSelectors();

  const {
    loanOffer: { overview, form },
    matchedMedia,
  } = useSelector((state: RootState) => state);

  const handleOpenPaymentScheduleModal = () => {
    dispatch(
      pushToGtmLoanAction({
        actionName: 'loan_offer_payment_plan_open',
      })
    );

    modals.openModal({
      header: <H7>{translate('PaymentCalculator.PaymentSchedule')}</H7>,
      children: (
        <PaymentCalculatorModal
          applicationUuid={overview.applicationUuid}
          amount={loanAmount}
          initialLoanPeriod={form.loanPeriod}
        />
      ),
      footer: (
        <Stack align="center">
          <Button variant="secondary" size="md" onClick={modals.closeAll}>
            {translate('Ok')}
          </Button>
        </Stack>
      ),
      fullScreen: matchedMedia.smallScreenPortrait,
      fixedHeaderAndFooter: matchedMedia.smallScreenPortrait,
      filledBackground: true,
      size: 'xl',
    });
  };

  return (
    <Stack spacing="xxl">
      <LoanOfferAdjustmentForm />
      <PaymentDetails />
      <Button
        size="md"
        variant="secondary"
        onClick={() => handleOpenPaymentScheduleModal()}
      >
        {translate('ViewPaymentSchedule')}
      </Button>
    </Stack>
  );
};

export default LoanOfferAdjustment;
